module.exports = __webpack_public_path__ + "img/local_network.4cdb732e.svg";